import { Box } from '@mui/material';
import { useAuthStore } from '../stores/auth.store';
import { useWorkspaceStore } from '../stores/workspace.store';
import { WorkspaceSelect } from './WorkspaceSelect';

/** The toolbar view selector. Empty = all (aggregate); hidden when the user has one workspace. */
export function WorkspaceSelector() {
  const workspaces = useAuthStore((s) => s.user?.workspaces ?? []);
  const selectedIds = useWorkspaceStore((s) => s.selectedIds);
  const setSelectedIds = useWorkspaceStore((s) => s.setSelectedIds);

  if (workspaces.length <= 1) return null;
  const valid = new Set(workspaces.map((w) => w.id));

  return (
    <Box sx={{ minWidth: 220, mr: 1 }}>
      <WorkspaceSelect
        multiple
        value={selectedIds.filter((id) => valid.has(id))}
        onChange={(v) => setSelectedIds(v as string[])}
        placeholder="All workspaces"
        sx={{ bgcolor: 'background.paper' }}
      />
    </Box>
  );
}
